// OTA display name overrides.
// Backend / DB values stay unchanged — only the UI label is remapped here.
export const getOtaDisplayName = (name) => {
    if (name === "akbartravels") return "Travex";
    return name;
};

// Replaces OTA identifiers inside error/toast message strings from the backend.
export const sanitizeOtaMessage = (msg) => {
    if (typeof msg !== "string") return msg;
    return msg.replace(/akbartravels/gi, "Travex");
};
